// extracted by css-extract-rspack-plugin
export default {"wrapper":"OjIfB","fade_leave":"UUVfA","fadeLeave":"UUVfA","rotated_icon":"srHna","rotatedIcon":"srHna","label":"ldkFy"};